import Bar from "./Bar";

// Received tab. Mirrors NotificationRow: unread dot, then type chip / title /
// body, with a timestamp pinned right — grouped under a day heading.
const ReceivedRow = () => (
  <div className="flex w-full items-start gap-4 px-5 py-4">
    <Bar w={8} h={8} r={4} className="mt-2 shrink-0" />

    <div className="min-w-0 flex-1">
      <div className="mb-1 flex items-center gap-2">
        <Bar w={6} h={6} r={3} />
        <Bar w={82} h={9} />
      </div>
      <Bar w="46%" h={13} className="mb-2" />
      <Bar w="78%" h={12} />
    </div>

    <Bar w={44} h={11} className="mt-1 shrink-0" />
  </div>
);

export const NotificationsReceivedSkeleton = ({ groups = 2, rows = 4 }) => (
  <div className="flex flex-col gap-8">
    {Array.from({ length: groups }, (_, g) => (
      <section key={g}>
        {/* the "TODAY" / "YESTERDAY" heading */}
        <Bar w={72} h={10} className="mb-3" />
        <div className="divide-y divide-gray-100 overflow-hidden rounded-2xl bg-white shadow-sm">
          {Array.from({ length: rows }, (_, i) => (
            <ReceivedRow key={i} />
          ))}
        </div>
      </section>
    ))}
  </div>
);

// Sent tab. Plain table: Date, Type chip, Recipient, Status, actions.
export const NotificationsSentSkeleton = ({ rows = 6 }) => (
  <div className="overflow-x-auto rounded-2xl bg-white shadow-sm">
    <table className="w-full text-left text-sm">
      <thead>
        <tr className="border-b border-gray-100">
          {["Date", "Type", "Recipient", "Status", ""].map((h, i) => (
            <th key={i} className="px-5 py-3">
              <Bar w={h ? 52 : 20} h={10} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-100">
        {Array.from({ length: rows }, (_, i) => (
          <tr key={i}>
            <td className="px-5 py-4">
              <Bar w={86} h={12} />
            </td>
            <td className="px-5 py-4">
              <Bar w={74} h={20} r={10} />
            </td>
            <td className="px-5 py-4">
              <Bar w={118} h={12} />
            </td>
            <td className="px-5 py-4">
              <Bar w={68} h={12} />
            </td>
            <td className="px-5 py-4">
              <div className="flex justify-end gap-3">
                <Bar w={20} h={20} />
                <Bar w={20} h={20} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
